import React, { useState } from 'react';
import { Button } from 'quanta-ui';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faEnvelope,
  faSms,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
// import { SEND_QUOTE_PDF_PCV } from '../../queries';
import { SEND_QUOTE_PDF_MISCD } from '../../queries';

//import useMutationQuery from '../../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';

export default function MainFragment({
  motorQuote,
  doClose,
  showEmail,
  showSMS,
  TWQuoteInput,
}) {
  const mutateQuery = useMutationQuery();

  const [downloadingPDF, setDownloadingPDF] = useState(false);
  return (
    <div className="divider-y-neutral h-full flex flex-col justify-between">
      <div>
        <Button
          iconPre={
            downloadingPDF ? (
              <FontAwesomeIcon icon={faSpinner} spin={true} />
            ) : (
              <FontAwesomeIcon icon={faDownload} size="2x" />
            )
          }
          size="full"
          flat
          type={'button'}
          className="border-none"
          disabled={downloadingPDF || motorQuote?.quotationNo === ''}
          onClick={async (_) => {
            try {
              const downloadTWQuotationPDF = mutateQuery({
                // mutation: SEND_QUOTE_PDF_PCV,
                mutation: SEND_QUOTE_PDF_MISCD,
                variables: TWQuoteInput,
              });
              setDownloadingPDF(true);
              const { data: dataBase64String } =
                await downloadTWQuotationPDF;
              const { sendQuotePDFTW } = dataBase64String;
              const { base64Pdf: downloadBase64String } =
                sendQuotePDFTW;
              setDownloadingPDF(false);

              let byteCharacters = atob(
                downloadBase64String.toString(),
              );
              let byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              let byteArray = new Uint8Array(byteNumbers);
              let file = new Blob([byteArray], {
                type: 'application/pdf;base64',
              });
              let fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            } catch (error) {
              setAlerts([
                {
                  id: Date.now(),
                  content: (
                    <div className="flex flex-col w-full h-full">
                      <Text type="normal">{error.message}</Text>
                    </div>
                  ),
                  type: 'error',
                  timeout: null,
                  disableClose: false,
                },
              ]);
              setDownloadingPDF(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          <span className="w-full flex items-left pl-4">
            {downloadingPDF ? 'Downloading...' : 'Download Quote'}
          </span>
        </Button>
        <Button
          iconPre={<FontAwesomeIcon icon={faEnvelope} size="2x" />}
          size="full"
          flat
          type={'button'}
          className="border-none justify-start"
          disabled={motorQuote?.quotationNo === ''}
          onClick={showEmail}
        >
          <span className="w-full flex items-left pl-4">
            Email Quotation
          </span>
        </Button>
        <Button
          iconPre={<FontAwesomeIcon icon={faSms} size="2x" />}
          size="full"
          flat
          type={'button'}
          className="border-none"
          disabled={motorQuote?.quotationNo === ''}
          onClick={showSMS}
        >
          <span className="w-full flex items-left pl-4">
            Message Quotation
          </span>
        </Button>
      </div>
      <div className="flex flex-col items-end">
        <Button
          type={'button'}
          size="small"
          flat
          className="w-24"
          onClick={doClose}
        >
          Close
        </Button>
      </div>
    </div>
  );
}
